import React, { ReactNode } from 'react';
import { DialogHeader, DialogTitle, DialogDescription } from "@/ui-components/ui/dialog";
import { cn } from "@/lib/utils/cn";
import { LucideIcon } from 'lucide-react';

interface StandardDialogHeaderProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  variant?: 'blue' | 'red';
}

export const StandardDialogHeader: React.FC<StandardDialogHeaderProps> = ({
  icon: Icon,
  title,
  description,
  className,
  variant = 'blue'
}) => {
  const styles = {
    blue: {
      bg: "bg-blue-50",
      border: "border-blue-100",
      text: "text-blue-600",
      line: "border-gray-100"
    },
    red: {
      bg: "bg-red-50",
      border: "border-red-100",
      text: "text-red-600",
      line: "border-red-100"
    }
  };

  const style = styles[variant];

  return (
    <DialogHeader className={cn(`border-b pb-4 ${style.line} text-left items-start sm:items-start`, className)}>
      <div className="flex items-center gap-3 w-full">
        <div className={cn("flex h-10 w-10 items-center justify-center rounded-xl flex-shrink-0 border", style.bg, style.border)}>
          <Icon className={cn("h-5 w-5", style.text)} />
        </div>
        <div className="flex-1 min-w-0">
          <DialogTitle className="text-lg font-semibold text-gray-900 flex items-center gap-2 text-left justify-start">
            {title}
          </DialogTitle>
          {description && (
            <DialogDescription className="text-sm text-gray-500 mt-0.5 text-left">
              {description}
            </DialogDescription>
          )}
        </div>
      </div>
    </DialogHeader>
  );
};
